export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	const licenseKey = config.public.CAPI_LICENSE_KEY
	const isCapiEnabled = licenseKey !== ''

	if (!isCapiEnabled) return

	useCarsalesCapi()
})
